module.exports = __webpack_public_path__ + "img/loupe.acc7a877.png";